export const formDefaultState = {
  lastNameValue: "",
  firstNameValue: "",
  emailValue: "",
  passwordValue: "",
  confirmPasswordValue: "",
  lastNameIsValid: null,
  firstNameIsValid: null,
  emailIsValid: null,
  passwordIsValid: null,
  confirmPasswordIsValid: null,
  formIsValid: null,
  error: {
    lastNameError: "",
    firstNameError: "",
    emailError: "",
    passwordError: "",
    confirmPasswordError: "",
  },
};
